import AuthenticationService from '../../service/AuthenticationService'
import { Button, Layout } from 'antd'
import { useEffect } from 'react'
import './index.css'

import MainMenu from '../../components/MainMenu/index.jsx'

const { Content, Footer } = Layout
const API_URL_PROD = 'http://192.168.100.223:3000/'
const API_URL_PROD2 = 'http://192.168.100.223/'
const API_URL_PROD3 = 'http://200.143.97.171/'
const API_URL_LOCAL = 'http://localhost:3000/'
function Home() {
  useEffect(() => {
    const logado = AuthenticationService.isUserLoggedIn
    if (!logado) {
      window.location.href = `${API_URL_PROD3}login`
    }
  }, [])

  return (
    <div className="container">
      <Layout className="layout">
        <MainMenu active="1"></MainMenu>
        <Content style={{ padding: '0 50px' }}>
          <div className="site-layout-content">
            <h2>PROCEDIMENTO DE HETEROIDENTIFICAÇÃO </h2>
            <p>
              O vídeo que será enviado ao IAUPE deve seguir algumas
              recomendações, conforme abaixo:
            </p>
            <p>
              a) Filmagem, em ambiente com boa iluminação, preferencialmente com
              luz natural, durante o dia, que não interfira na qualidade de
              imagem;
            </p>
            <p>
              b) O fundo do vídeo deve ser de uma única cor, clara e neutra,
              preferencialmente de cor branca;
            </p>
            <p>c) Que o(a) candidato(a) tenha postura corporal reta;</p>
            <p>
              d) Que o(a) candidato(a) não esteja de cabeça baixa, nem de cabeça
              erguida;
            </p>
            <p>
              e) No momento da gravação, utilizar o equipamento de gravação na
              posição horizontal, em que o(a) candidato(a) se posicione de forma
              centralizada, de modo que seja possível visualizar da cabeça
              (inteira) até o braço (região logo acima do cotovelo);
            </p>
            <p>
              f) É vedado o uso de maquiagem, óculos (escuros ou de grau), peças
              de vestuário que cubram o braço (tais como camisa ou blusa de manga
              longa), máscara, chapéu, boné, turbante, gorro ou outro adereço
              análogo, durante a gravação, bem como a utilização de filtros de
              edição ou qualquer outro artifício que impossibilite ou dificulte a
              percepção de suas características fenotípicas, tais como: cor dos
              olhos, textura dos cabelos, tom de pele, e formato de lábios, boca
              e nariz;
            </p>
            <p>
              g) Não usar qualquer programa, aplicativo ou recurso para editar a
              imagem do vídeo, tais como: o uso de filtros e/ou aplicativos,
              para modificar a imagem do vídeo gravado. O vídeo deve ser gravado
              de maneira contínua, sem edições de imagem, cortes ou
              interrupções;
            </p>
            <p>
              h) O(A) candidato(a) deverá nomear cada arquivo com os dizeres:
              “Vídeo + [nome completo do candidato(a)]”;
            </p>
            <p>
              i) O vídeo deve estar na extensão MP4, com o tamanho máximo de 50
              MB (megabytes).
            </p>
            <br />
            <p>
              O vídeo que será enviado ao IAUPE deve seguir o seguinte roteiro
              de filmagem indicado no Edital do respectivo certame.
            </p>
            <Button
              type="primary"
              size="default"
              onClick={() => AuthenticationService.logout()}
            >
              Sair
            </Button>
          </div>
        </Content>
        <Footer style={{ textAlign: 'center' }}>IAUPE ©2023 </Footer>
      </Layout>
    </div>
  )
}

export default Home
